import { type Component, For } from "solid-js";
import StarIcon from "~/Icons/startIcon.svg?component-solid";
import { CustomImage } from "~/solidJs/shared";
import type { FeedBackListItem } from "../model";

export const PricingFeedBackCard: Component<FeedBackListItem> = (props) => {
	return (
		<div class="flex h-full w-[90%] shrink-0 flex-col items-start justify-between rounded-2xl border border-border-secondary p-5 xl:w-max xl:flex-1">
			<div class="flex flex-col items-start gap-4">
				<div class="flex gap-1">
					<For each={Array.from({ length: 5 })}>{() => <StarIcon class="size-4" />}</For>
				</div>
				<div class="typography-text-14-medium text-text-primary">{props.feedBack}</div>
			</div>
			<div class="flex w-full shrink-0 justify-start gap-4">
				<CustomImage
					src={props.userPick}
					containerClassName="size-[75px]"
					style={{ "border-radius": "20px" }}
				/>
				<div class="flex flex-col gap-2">
					{/*<props.Icon />*/}
					<div class="flex flex-col justify-center">
						<h2 class="typography-text-16-medium text-text-primary">{props.name}</h2>
						<div class="typography-text-14-medium text-text-secondary">
							{props.position}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
